import { render, staticRenderFns } from "./matchConf.vue?vue&type=template&id=e511853a&"
import script from "./matchConf.vue?vue&type=script&lang=js&"
export * from "./matchConf.vue?vue&type=script&lang=js&"
import style0 from "./matchConf.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports